export default __webpack_public_path__ + "static/media/symptoms.c5d5a138.svg";